export default {
  'pages.covenantDevice.mac': 'MAC Address',
  'pages.admin.providerCard.config.grpcAddr': 'gRPC Address',
  'pages.covenantDevice.cardTitle': 'Covenant Device Management',
  'pages.admin.whitelist.mac': 'MAC Address',
  'pages.covenantDevice.operations': 'Operations',
  'pages.covenantDevice.expireTime': 'Expiration Time',
  'pages.covenantDevice.updateTime': 'Update Time',
  'pages.admin.ops.logViewer.previewTitle': 'Log Preview',
  'pages.admin.ops.logViewer.fileName': 'File Name:',
  'pages.admin.ops.logViewer.lineCount': 'Lines:',
  'pages.admin.ops.logViewer.previewBtn': 'Preview',
  'pages.admin.ops.logViewer.noContent': 'No content',
  'pages.unbindDevice.titleAdmin': 'Unbind Device (Admin Required)',
  'pages.unbindDevice.inputPlaceholder': 'Please enter device ID',
  'pages.unbindDevice.unbind': 'Unbind',
  'pages.unbindDevice.unbinding': 'Unbinding...',
  'pages.unbindDevice.success': 'Unbind successful',
  'pages.unbindDevice.fail': 'Unbind failed',
  'pages.layouts.userLayout.title': 'Management Console',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: ant.design',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': ' sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage': 'Faster and stronger heavy-duty components have been released.',
  'pages.welcome.defaultTitle': 'Admin Console',
  'pages.welcome.guest': 'User',
  'pages.welcome.greeting.morning': 'Good morning',
  'pages.welcome.greeting.afternoon': 'Good afternoon',
  'pages.welcome.greeting.evening': 'Good evening',
  'pages.welcome.greeting.night': 'Good night',
  'pages.welcome.heroTitle': 'Welcome to {title}',
  'pages.welcome.role.admin': 'Administrator',
  'pages.welcome.role.observer': 'Observer',
  'pages.welcome.role.enterprise': 'Enterprise Account',
  'pages.welcome.role.user': 'Standard User',
  'pages.welcome.quickActions': 'Quick Actions',
  'pages.welcome.action.agents.title': 'Agents',
  'pages.welcome.action.agents.desc': 'Create and manage AI agents, bind devices',
  'pages.welcome.action.knowledge.title': 'Knowledge Bases',
  'pages.welcome.action.knowledge.desc': 'Upload documents to power your agents',
  'pages.welcome.action.voiceClone.title': 'Voice Clone',
  'pages.welcome.action.voiceClone.desc': 'Customize voices for more personal conversations',
  'pages.welcome.action.dashboard.title': 'Dashboard',
  'pages.welcome.action.dashboard.desc': 'View users, devices, and system status',
  'pages.welcome.action.userManage.title': 'User Management',
  'pages.welcome.action.userManage.desc': 'Manage users and access control',
  'pages.welcome.action.settings.title': 'System Settings',
  'pages.welcome.action.settings.desc': 'Configure models, parameters, and global options',
  'pages.welcome.action.tenant.title': 'Enterprise Info',
  'pages.welcome.action.tenant.desc': 'View and manage enterprise profile and licenses',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.admin.subPage.title': 'This page can only be viewed by Admin',
  'pages.admin.subPage.alertMessage': 'Umi ui is now released, welcome to use npm run ui to start the experience.',
  'pages.searchTable.createForm.newRule': 'New Rule',
  'pages.searchTable.updateForm.ruleConfig': 'Rule configuration',
  'pages.searchTable.updateForm.basicConfig': 'Basic Information',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Rule Name',
  'pages.searchTable.updateForm.ruleName.nameRules': 'Please enter the rule name!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Rule Description',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Please enter at least five characters',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Please enter a rule description of at least five characters!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configure Properties',
  'pages.searchTable.updateForm.object': 'Monitoring Object',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Rule Template',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Rule Type',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Set Scheduling Period',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Starting Time',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Please choose a start time!',
  'pages.searchTable.titleDesc': 'Description',
  'pages.searchTable.ruleName': 'Rule name is required',
  'pages.searchTable.titleCallNo': 'Number of Service Calls',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'default',
  'pages.searchTable.nameStatus.running': 'running',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'abnormal',
  'pages.searchTable.titleUpdatedAt': 'Last Scheduled at',
  'pages.searchTable.exception': 'Please enter the reason for the exception!',
  'pages.searchTable.titleOption': 'Option',
  'pages.searchTable.config': 'Configuration',
  'pages.searchTable.subscribeAlert': 'Subscribe to alerts',
  'pages.searchTable.title': 'Enquiry Form',
  'pages.searchTable.new': 'New',
  'pages.searchTable.chosen': 'chosen',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Total Number of Service Calls',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'batch deletion',
  'pages.searchTable.batchApproval': 'batch approval',
      'pages.register.phone.tab': 'Phone Registration',
  'pages.register.email.tab': 'Email Registration',
  'pages.register.emailCode.placeholder': 'Email verification code',
  'pages.register.emailCode.required': 'Please enter email verification code!',
  'pages.register.emailCode.length': 'Verification code must be 6 digits',
  'pages.register.emailCode.get': 'Get code',
  'pages.register.emailCode.sent': 'Verification code sent',
  'pages.register.emailCode.sendFailed': 'Failed to send',
  'pages.register.phone.optionalPlaceholder': 'Phone number (optional)',
  'pages.register.phone.onlyChinaHint': 'Currently only mainland China phone numbers are supported, please try using email registration',

  // Agents page related text
  'pages.agents.search.placeholder': 'Search agents',
  'pages.agents.create.button': 'Create Agent',
  'pages.agents.addDevice.button': 'Add Device',
  'pages.agents.create.modal.title': 'Create Agent',
  'pages.agents.create.modal.nameLabel': 'Agent Name',
  'pages.agents.create.modal.placeholder': 'Please enter agent name',
  'pages.agents.card.id': 'ID',
  'pages.agents.card.voiceModel': 'Voice Model',
  'pages.agents.card.languageModel': 'Language Model',
  'pages.agents.card.lastChat': 'Last Chat',
  'pages.agents.card.conversationId': 'Conversation ID',
  'pages.agents.card.clearConversation': 'Clear Conversation ID',
  'pages.agents.card.clearConversation.success': 'Conversation ID cleared',
  'pages.agents.card.clearConversation.error': 'Failed to clear conversation ID',
  'pages.agents.card.configRole': 'Configure Role',
  'pages.agents.card.voiceRecognition': 'Voice Recognition',
  'pages.agents.card.voiceRecognition.developing': 'Feature under development, please stay tuned',
  'pages.agents.card.historyDialog': 'History Dialog',
  'pages.agents.card.manageDevice': 'Manage Devices',
  'pages.agents.card.addDevice': 'Add Device',
  'pages.agents.loading': 'Loading agent list...',
  'pages.agents.reload': 'Reload',
  'pages.agents.empty.title': 'No agents available',
  'pages.agents.empty.createFirst': 'Create your first agent',
  'pages.agents.delete.title': 'Confirm Delete Agent',
  'pages.agents.delete.content': 'After deleting the agent, all related configurations (including device-related conversation records) cannot be recovered. Are you sure you want to delete?',
  'pages.agents.delete.confirm': 'Confirm Delete',
  'pages.agents.fetch.error': 'Failed to fetch agent list',
  'pages.agents.network.error': 'Network error, please try again later',
  'pages.agents.speed.patient': 'Patient',
  'pages.agents.speed.normal': 'Normal',
  'pages.agents.speed.fast': 'Fast',
  'pages.agents.lastChat.none': 'None',
  'pages.agents.language.chinese': 'Chinese',
  'pages.agents.loading.tts.error': 'Failed to load TTS voices',
  'pages.agents.loading.llm.error': 'Failed to load LLM providers',
  'pages.agents.sort.id': 'Sort by ID',
  'pages.agents.sort.updatedAt': 'Sort by last modified',
  'pages.agents.sort.lastConversationAt': 'Sort by last conversation',

  // Register page related text
  'pages.register': 'Register',
  'pages.register.title': 'Register',
  'pages.register.form.title': 'Register New Account',
  'pages.register.submit': 'Register',
  'pages.register.username.placeholder': 'Please enter username',
  'pages.register.username.required': 'Please enter username!',
  'pages.register.username.min': 'Username must be at least 3 characters',
  'pages.register.phone.placeholder': 'Please enter phone number',
  'pages.register.phone.required': 'Please enter phone number!',
  'pages.register.phone.invalid': 'Please enter a valid phone number!',
  'pages.register.smsCode.placeholder': 'SMS verification code',
  'pages.register.smsCode.required': 'Please enter SMS verification code!',
  'pages.register.smsCode.length': 'Verification code must be 6 digits',
  'pages.register.smsCode.get': 'Get code',
  'pages.register.smsCode.sent': 'Verification code sent',
  'pages.register.email.placeholder': 'Please enter email',
  'pages.register.email.optionalPlaceholder': 'Email (optional)',
  'pages.register.email.required': 'Please enter email!',
  'pages.register.email.invalid': 'Please enter a valid email address!',
  'pages.register.backToLogin': 'Already have an account? Sign in',
  'pages.register.password.placeholder': 'Please enter password',
  'pages.register.password.required': 'Please enter password!',
  'pages.register.password.min': 'Password must be at least 6 characters',
  'pages.register.password.pattern': 'Password must contain uppercase, lowercase letters and numbers',
  'pages.register.confirmPassword.placeholder': 'Please confirm password',
  'pages.register.confirmPassword.required': 'Please confirm password!',
  'pages.register.confirmPassword.min': 'Password must be at least 6 characters',
  'pages.register.error.passwordMismatch': 'The two passwords do not match',
  'pages.register.error.registerFailed': 'Registration failed, please try again!',
  'pages.register.success': 'Registration successful!',

  // Login page related text
  'pages.login.title': 'Anime AI Chat Management Console',
  'pages.login.actionIcons.notImplemented': 'Not implemented yet, coming soon',
  'pages.login.mobile.captchaError': 'Verification code error',
  'pages.login.captcha.success': 'Verification code sent successfully! Code: 1234',
  'pages.login.forgotPassword.contactAdmin': 'Please contact administrator',
  'pages.login.mobile.notAvailable': 'This feature is not available yet, please use account login',

  // ForgotPassword page
  'pages.forgotPassword.title': 'Forgot Password',
  'pages.forgotPassword.form.title': 'Reset Password',
  'pages.forgotPassword.form.subtitle': 'Verify your phone number or email to set a new password',
  'pages.forgotPassword.mode.phone': 'Phone',
  'pages.forgotPassword.mode.email': 'Email',
  'pages.forgotPassword.submit': 'Reset Password',
  'pages.forgotPassword.phone.placeholder': 'Registered phone number',
  'pages.forgotPassword.phone.required': 'Please enter phone number!',
  'pages.forgotPassword.phone.invalid': 'Please enter a valid phone number!',
  'pages.forgotPassword.smsCode.placeholder': 'SMS verification code',
  'pages.forgotPassword.smsCode.required': 'Please enter SMS verification code!',
  'pages.forgotPassword.smsCode.length': 'Verification code must be 6 digits',
  'pages.forgotPassword.smsCode.get': 'Get code',
  'pages.forgotPassword.smsCode.sent': 'Verification code sent',
  'pages.forgotPassword.email.placeholder': 'Registered email',
  'pages.forgotPassword.email.required': 'Please enter email!',
  'pages.forgotPassword.email.invalid': 'Please enter a valid email!',
  'pages.forgotPassword.emailCode.placeholder': 'Email verification code',
  'pages.forgotPassword.emailCode.required': 'Please enter email verification code!',
  'pages.forgotPassword.emailCode.length': 'Verification code must be 6 digits',
  'pages.forgotPassword.emailCode.get': 'Get code',
  'pages.forgotPassword.emailCode.sent': 'Verification code sent to your email',
  'pages.forgotPassword.newPassword.placeholder': 'New password',
  'pages.forgotPassword.newPassword.required': 'Please enter new password!',
  'pages.forgotPassword.newPassword.min': 'Password must be at least 6 characters',
  'pages.forgotPassword.confirmPassword.placeholder': 'Confirm new password',
  'pages.forgotPassword.confirmPassword.required': 'Please confirm new password!',
  'pages.forgotPassword.error.passwordMismatch': 'The two passwords do not match',
  'pages.forgotPassword.error.resetFailed': 'Password reset failed, please try again',
  'pages.forgotPassword.success': 'Password reset successful, please sign in with your new password',
  'pages.forgotPassword.backToLogin': 'Back to sign in',

  // AgentSetting page related text
  'pages.agentSetting.title': 'Configure Role',
  'pages.agentSetting.back': 'Back',
  'pages.agentSetting.roleTemplate.title': 'Role Template',
  'pages.agentSetting.roleTemplate.label': 'Template',
  'pages.agentSetting.template.taiwanGirlfriend': 'Taiwan Girlfriend',
  'pages.agentSetting.template.potato': 'Potato',
  'pages.agentSetting.template.englishTutor': 'English Tutor',
  'pages.agentSetting.template.curiousBoy': 'Curious Boy',
  'pages.agentSetting.template.puppyLeader': 'Puppy Leader',
  'pages.agentSetting.basicConfig.title': 'Basic Configuration',
  'pages.agentSetting.assistantName.label': 'Assistant Name',
  'pages.agentSetting.assistantName.placeholder': 'Please enter assistant name',
  'pages.agentSetting.assistantName.required': 'Please enter assistant name',
  'pages.agentSetting.dialogLanguage.label': 'Dialog Language',
  'pages.agentSetting.dialogLanguage.placeholder': 'Select dialog language',
  'pages.agentSetting.voiceType.label': 'Voice Type',
  'pages.agentSetting.voiceType.placeholder': 'Select voice type',
  'pages.agentSetting.voiceType.preview': 'Preview',
  'pages.agentSetting.voiceType.previewMissing': 'No preview audio for this voice',
  'pages.agentSetting.voiceType.previewFail': 'Failed to play preview',
  'pages.agentSetting.roleDescription.title': 'Role Description',
  'pages.agentSetting.roleDescription.label': 'Role Description',
  'pages.agentSetting.roleDescription.placeholder': 'Please enter role description',
  'pages.agentSetting.roleDescription.required': 'Please enter role description',
  'pages.agentSetting.roleDescription.custom': 'Custom',
  'pages.agentSetting.roleDescription.presetLabel': 'Preset intro',
  'pages.agentSetting.roleDescription.presetHint': 'Turning off custom uses the template preset for the current dialog language',
  'pages.agentSetting.roleDescription.restorePreset': 'Restore preset',
  'pages.agentSetting.roleDescription.restorePresetDone': 'Restored to preset; you can edit from here',
  'pages.agentSetting.roleDescription.restoredCustom': 'Restored your last custom content',
  'pages.agentSetting.roleDescription.selectTemplateFirst': 'Select a role template first before turning off custom to use the preset',
  'pages.agentSetting.languageModel.title': 'Language Model',
  'pages.agentSetting.languageModel.label': 'Language Model',
  'pages.agentSetting.languageModel.placeholder': 'Select language model',
  'pages.agentSetting.languageModel.tip': 'After changing the model, it is recommended to clear the memory to avoid affecting the chat experience.',
  'pages.agentSetting.thinkingEnabled.label': 'Enable thinking mode',
  'pages.agentSetting.thinkingEnabled.tip': 'When on, replies may be slower; spoken output still filters out thinking.',
  'pages.agentSetting.advancedSettings.expand': 'Expand Advanced Settings',
  'pages.agentSetting.advancedSettings.collapse': 'Collapse Advanced Settings',
  'pages.agentSetting.recognitionSpeed.label': 'Speech Recognition Speed',
  'pages.agentSetting.recognitionSpeed.placeholder': 'Select recognition speed',
  'pages.agentSetting.intentMergeEnabled.label': 'Smart no-reply L3 (dialog.no_reply)',
  'pages.agentSetting.intentMergeEnabled.tooltip':
    'Override system “main dialog L3”: follow global / force on / force off. L3 lets the model decline a reply in the same generation; works with global L1/L2/L2.5. Prefer force off for child-companion roles to avoid false silence.',
  'pages.agentSetting.intentMergeEnabled.inherit': 'Follow global',
  'pages.agentSetting.intentMergeEnabled.on': 'Force on',
  'pages.agentSetting.intentMergeEnabled.off': 'Force off',
  'pages.agentSetting.speechSpeed.label': 'Speech Speed',
  'pages.agentSetting.speechSpeed.placeholder': 'Select speech speed',
  'pages.agentSetting.pitchValue.label': 'Character Volume',
  'pages.agentSetting.button.reset': 'Reset',
  'pages.agentSetting.button.save': 'Save',
  'pages.agentSetting.save.success': 'Save successful',
  'pages.agentSetting.save.error': 'Save failed',
  'pages.agentSetting.save.missingId': 'Missing agent id, unable to save',
  'pages.agentSetting.load.tts.error': 'Failed to load TTS voices',
  'pages.agentSetting.speed.slow': 'Slow',
  'pages.agentSetting.speed.normal': 'Normal',
  'pages.agentSetting.speed.fast': 'Fast',
  'pages.agentSetting.speed.patient': 'Patient',
  'pages.agentSetting.language.chinese': 'Chinese',
  'pages.agentSetting.language.english': 'English',
  'pages.agentSetting.language.cloned': 'Cloned voices',
  'pages.agentSetting.voiceClone.optionLabel': '[Clone] {name}',
  'pages.voiceClone.fieldLanguage': 'Language',
  'pages.voiceClone.fieldLanguageHint':
    'Used in Agent settings to group this clone with preset voices of the same language. Legacy rows show as empty until re-saved.',
  'pages.voiceClone.fieldLanguagePlaceholder': 'Select the language for this clone',
  'pages.voiceClone.fieldRefText': 'Reference script',
  'pages.voiceClone.fieldRefTextHint':
    'Enter the exact text spoken in the reference audio (CosyVoice requires a verbatim match with the recording).',
  'pages.voiceClone.fieldRefTextPlaceholder':
    'Example: When the dream day ends in utter ignorance, a new cycle begins.',
  'pages.voiceClone.fieldAlias': 'Name',
  'pages.voiceClone.fieldProvider': 'Provider',
  'pages.voiceClone.fieldProviderPlaceholder': 'Select a voice clone provider',
  'pages.voiceClone.colCloneId': 'Clone ID',
  'pages.voiceClone.colSampleId': 'Sample ID',
  'pages.voiceClone.colSampleAlias': 'Sample name',
  'pages.voiceClone.colSampleText': 'Sample reference text',
  'pages.voiceClone.colVoiceUri': 'Voice URI',
  'pages.voiceClone.colCreatedAt': 'Created at',
  'pages.voiceClone.colUpdatedAt': 'Updated at',
  'pages.voiceClone.addTitle': 'Add voice clone',
  'pages.voiceClone.sampleUploaded': 'Voice sample uploaded',
  'pages.voiceClone.uploadSampleFailed': 'Failed to upload sample',
  'pages.voiceClone.step1Button': 'Upload sample (step 1)',
  'pages.voiceClone.backToStep1': 'Back to edit sample',
  'pages.voiceClone.cloneSuccess': 'Clone saved',
  'pages.voiceClone.cloneFailed': 'Clone training failed',
  'pages.voiceClone.step2Button': 'Start clone training (step 2)',
  'pages.voiceClone.step1Title': 'Upload voice sample',
  'pages.voiceClone.step1Desc':
    'Fill in name, reference text, and provider; record or upload a WAV (≤5MB), trim 8–20s in the confirmation panel, then upload the sample.',
  'pages.voiceClone.step2Title': 'Cloud clone training',
  'pages.voiceClone.step2Desc': 'Calls the provider API; may take a while',
  'pages.voiceClone.step2AlertTitle': 'Sample is ready on the server',
  'pages.voiceClone.step2AlertDesc':
    'Click “Start clone training” to run training (e.g. SiliconFlow). Do not close the page until it finishes.',
  'pages.voiceClone.selectWavTip': 'Select a WAV file',
  'pages.voiceClone.tabClones': 'Clones',
  'pages.voiceClone.cloneList': 'Voice clones',
  'pages.voiceClone.tabOrders': 'Quota pack orders',
  'pages.agentSetting.language.spanish': 'Spanish',
  'pages.agentSetting.language.french': 'French',
  'pages.agentSetting.language.german': 'German',
  'pages.agentSetting.language.japanese': 'Japanese',
  'pages.agentSetting.language.korean': 'Korean',
  'pages.agentSetting.language.portuguese': 'Portuguese',
  'pages.agentSetting.language.arabic': 'Arabic',
  'pages.agentSetting.language.russian': 'Russian',
  'pages.agentSetting.language.italian': 'Italian',
  'pages.agentSetting.language.turkish': 'Turkish',
  'pages.agentSetting.language.polish': 'Polish',
  'pages.agentSetting.language.catalan': 'Catalan',

  // DeviceManagement page related text
  'pages.devices.title': 'Manage Devices',
  'pages.devices.breadcrumb.agents': 'Agents',
  'pages.devices.breadcrumb.devices': 'Manage Devices',
  'pages.devices.button.addDevice': 'Add Device',
  'pages.devices.warning.noAgentId': 'No agentId specified, unable to get device list',
  'pages.devices.device.unnamed': 'Unnamed Device',
  'pages.devices.device.macAddress': 'Mac Address',
  'pages.devices.device.lastActive': 'Last Active',
  'pages.devices.device.firmwareVersion': 'Firmware Version',
  'pages.devices.device.otaUpgrade': 'OTA Upgrade',
  'pages.devices.device.noData': 'No Data',
  'pages.devices.copy.success': 'MAC address copied',
  'pages.devices.unbind.title': 'Confirm Unbind Device',
  'pages.devices.unbind.content': 'Device unbinding cannot be recovered. If you need to use it again, you need to rebind it. Are you sure to unbind?',
  'pages.devices.unbind.confirm': 'Confirm Unbind',
  'pages.devices.unbind.cancel': 'Cancel',
  'pages.devices.unbind.success': 'Device unbound',
  'pages.devices.unbind.error': 'Unbind failed',
  'pages.devices.ota.enabled': 'OTA upgrade enabled',
  'pages.devices.ota.disabled': 'OTA upgrade disabled',
  'pages.devices.simUsage.button': 'Usage',
  'pages.devices.simRecharge.button': 'Data plan top-up',

  // Web console — SIM recharge (SimRecharge)
  'pages.simRecharge.refundCol': 'Refund',
  'pages.simRecharge.refundBtn': 'Request WeChat refund',
  'pages.simRecharge.refundBtnRetry': 'Retry refund request',
  'pages.simRecharge.refundTagSuccess': 'Refunded',
  'pages.simRecharge.refundTagProcessing': 'Refund processing',
  'pages.simRecharge.refundProcessingTip': 'WeChat is processing the refund; click again if it stays pending',
  'pages.simRecharge.refundUnavailable': '—',
  'pages.simRecharge.refundNoWechat': 'No WeChat payment',
  'pages.simRecharge.refundConfirmTitle': 'Request a full WeChat refund?',
  'pages.simRecharge.refundConfirmContent':
    'Order {no} will request a full refund to your original payment method. Timing follows WeChat. Continue?',
  'pages.simRecharge.refundConfirmOk': 'Confirm',
  'pages.simRecharge.refundConfirmCancel': 'Cancel',
  'pages.simRecharge.refundOk': 'Refund request submitted',
  'pages.simRecharge.refundFail': 'Refund failed',
  'pages.simRecharge.cancelFail': 'Failed to cancel order',
  'pages.simRecharge.colActions': 'Actions',
  'pages.simRecharge.viewDetail': 'Details',
  'pages.simRecharge.orderDetailTitle': 'Order details',
  'pages.simRecharge.detailLoadFail': 'Failed to load order details',
  'pages.simRecharge.detailSecOrder': 'Order & payment',
  'pages.simRecharge.detailSecDevice': 'Device',
  'pages.simRecharge.detailSecAgent': 'Agent',
  'pages.simRecharge.detailSecSimCard': 'SIM (at order time)',
  'pages.simRecharge.detailSecPackage': 'Plan',
  'pages.simRecharge.d.orderNo': 'Order no.',
  'pages.simRecharge.d.status': 'Status',
  'pages.simRecharge.d.amount': 'Amount',
  'pages.simRecharge.d.payChannel': 'Pay channel',
  'pages.simRecharge.d.wechatTradeNo': 'WeChat transaction ID',
  'pages.simRecharge.d.paidAt': 'Paid at',
  'pages.simRecharge.d.createdAt': 'Created at',
  'pages.simRecharge.d.failedReason': 'Failure reason',
  'pages.simRecharge.d.rechargeError': 'IoT recharge error',
  'pages.simRecharge.d.refundStatus': 'Refund status',
  'pages.simRecharge.d.devId': 'Device ID',
  'pages.simRecharge.d.devName': 'Device name',
  'pages.simRecharge.d.devMac': 'Device MAC',
  'pages.simRecharge.d.devIccid': 'Device ICCID (current)',
  'pages.simRecharge.d.agentId': 'Agent ID',
  'pages.simRecharge.d.agentName': 'Agent name',
  'pages.simRecharge.d.iccid': 'ICCID',
  'pages.simRecharge.d.iotSCode': 'IoT number (iotSCode)',
  'pages.simRecharge.d.providerCode': 'SIM provider code',
  'pages.simRecharge.d.platformOrder': 'Platform order no.',
  'pages.simRecharge.d.pkgId': 'Plan ID',
  'pages.simRecharge.d.pkgName': 'Plan name',
  'pages.simRecharge.d.pkgPlatCode': 'Platform plan code',
  'pages.simRecharge.d.pkgPrice': 'Price at order',
  'pages.simRecharge.d.pkgProvName': 'Plan provider',
  'pages.simRecharge.d.pkgProvCode': 'Provider code',

  'pages.devices.simUsage.title': 'In-plan GPRS usage (real-time)',
  'pages.devices.simUsage.errorUnknown': 'Query failed',
  'pages.devices.simUsage.sectionUsage': 'Usage from platform',
  'pages.devices.simUsage.field.provider_name': 'IoT platform',
  'pages.devices.simUsage.field.provider_code': 'Platform code',
  'pages.devices.simUsage.field.iccid': 'ICCID',
  'pages.devices.simUsage.field.platform_message': 'Platform message',
  'pages.devices.simUsage.field.number': 'MSISDN',
  'pages.devices.simUsage.field.total': 'Total (MB)',
  'pages.devices.simUsage.field.left': 'Remaining (MB)',
  'pages.devices.simUsage.field.used': 'Used (MB)',
  'pages.devices.simUsage.field.prodname': 'Plan name',
  'pages.devices.simUsage.field.prodid': 'Plan ID',
  'pages.devices.simUsage.field.prodinstid': 'Product instance ID',

  'pages.devices.simCard.button': 'SIM info',
  'pages.devices.simCard.title': 'IoT SIM card info',
  'pages.devices.simCard.errorUnknown': 'Query failed',
  'pages.devices.simCard.sectionCard': 'Card details',
  'pages.devices.simCard.sectionPackages': 'Orderable plans (price hidden)',
  'pages.devices.simCard.field.provider_name': 'IoT platform',
  'pages.devices.simCard.field.provider_code': 'Platform code',
  'pages.devices.simCard.field.iccid': 'ICCID',
  'pages.devices.simCard.field.platform_message': 'Platform message',
  'pages.devices.simCard.field.iotSCode': 'Operator card number',
  'pages.devices.simCard.field.iotsCode': 'Operator card number',
  'pages.devices.simCard.field.iotscode': 'Operator card number',
  'pages.devices.simCard.field.IMSI': 'IMSI',
  'pages.devices.simCard.field.CSDate': 'Test period end',
  'pages.devices.simCard.field.CMDate': 'Silent period end',
  'pages.devices.simCard.field.FWDate': 'Service expiry',
  'pages.devices.simCard.field.JHDate': 'Activation time',
  'pages.devices.simCard.field.Sp': 'Carrier',
  'pages.devices.simCard.field.sp': 'Carrier',
  'pages.devices.simCard.field.cardform': 'Card form factor',
  'pages.devices.simCard.field.cardcl': 'Lifecycle phase',
  'pages.devices.simCard.field.cstate': 'Card status',
  'pages.devices.simCard.field.usedFlow': 'Used data (MB)',
  'pages.devices.simCard.field.surplusFlow': 'Remaining data (MB)',
  'pages.devices.simCard.field.monthTotalFlow': 'Monthly total (MB)',
  'pages.devices.simCard.field.outRepositoryTime': 'Out-warehouse time',
  'pages.devices.simCard.field.customerRemark': 'Customer remark',
  'pages.devices.simCard.field.gprsState': 'GPRS status',
  'pages.devices.simCard.field.cardState': 'Card service state (platform)',
  'pages.devices.simCard.field.packageList': 'Orderable plans',
  'pages.devices.simCard.field.packageCode': 'Plan code',
  'pages.devices.simCard.field.packageName': 'Plan name',

  // HistoryDialogs page related text
  'pages.historyDialogs.title': 'History Dialogs',
  'pages.historyDialogs.breadcrumb.agents': 'Agents',
  'pages.historyDialogs.breadcrumb.historyDialogs': 'History Dialogs',
  'pages.historyDialogs.empty.title': 'No conversation selected',
  'pages.historyDialogs.empty.description': 'Please select a conversation',
  'pages.historyDialogs.agent': 'Agent',
  'pages.historyDialogs.agent.id': 'id',
  'pages.historyDialogs.conversationDetail': 'Conversation Details',
  'pages.historyDialogs.selectConversation': 'Please select a conversation',
  'pages.historyDialogs.delete.title': 'Delete Conversation',
  'pages.historyDialogs.delete.content': 'The conversation cannot be recovered after deletion. Please confirm the operation.',
  'pages.historyDialogs.delete.confirm': 'Confirm',
  'pages.historyDialogs.delete.cancel': 'Cancel',
  'pages.historyDialogs.batchDelete.selectAll': 'Select All',
  'pages.historyDialogs.batchDelete.button': 'Batch Delete',
  'pages.historyDialogs.batchDelete.title': 'Batch Delete Conversations',
  'pages.historyDialogs.batchDelete.content': 'Are you sure you want to delete the selected {count} conversation(s)? This action cannot be undone.',
  'pages.historyDialogs.batchDelete.success': 'Deleted {count} conversation(s)',
  'pages.historyDialogs.batchDelete.fail': 'Batch delete failed',
  'pages.historyDialogs.message.delete.confirm': 'Are you sure you want to delete this message? It cannot be recovered after deletion.',
  'pages.historyDialogs.detail.title': 'Conversation Details',
  'pages.historyDialogs.list.noTitle': 'Untitled conversation',
  'pages.historyDialogs.agent.label': 'Agent:',
  'pages.historyDialogs.user.label': 'User:',
  'pages.historyDialogs.loading': 'Loading...',
  'pages.historyDialogs.error.loadFailed': 'Failed to load conversation list',
  'pages.historyDialogs.error.deleteFailed': 'Failed to delete conversation',
  'pages.historyDialogs.success.deleteSuccess': 'Conversation deleted successfully',
  'pages.historyDialogs.noAudioHint':
    'No playable recording for this conversation. It may not have been saved, or it is past the listening window.',
  'pages.historyDialogs.audioRetainHint':
    'Recordings can be replayed for the last {hours} hours by default; older ones are no longer available.',

  // MessageList page related text
  'pages.messageList.empty': 'No messages',
  'pages.messageList.user': 'User',
  'pages.messageList.ai': 'AI',
  'pages.messageList.playAudio': 'Play recording',
  'pages.messageList.audioPlayFailed': 'Audio missing or expired',
  'pages.messageList.toolCall': 'Tool call: {name}',
  'pages.messageList.toolArgs': 'Arguments',
  'pages.messageList.toolResult': 'Result',
  'pages.messageList.copied': 'Copied',
  'pages.messageList.copyFailed': 'Copy failed',

  // Settings page related text
  'pages.settings.basicInfo.title': 'Basic Information',
  'pages.settings.avatar.label': 'Avatar:',
  'pages.settings.avatar.change': 'Change Avatar',
  'pages.settings.avatar.updateSuccess': 'Avatar updated successfully',
  'pages.settings.avatar.updateFailed': 'Failed to update avatar',
  'pages.settings.username.label': 'Username:',
  'pages.settings.nickname.label': 'Nickname:',
  'pages.settings.nickname.change': 'Edit Nickname',
  'pages.settings.nickname.modal.title': 'Edit Nickname',
  'pages.settings.nickname.form.label': 'New Nickname',
  'pages.settings.nickname.form.required': 'Please enter new nickname',
  'pages.settings.nickname.form.length': 'Nickname length should be 2-20 characters',
  'pages.settings.nickname.updateSuccess': 'Nickname updated successfully',
  'pages.settings.nickname.updateFailed': 'Failed to update nickname',
  'pages.settings.registerTime.label': 'Registration Time:',
  'pages.settings.email.label': 'Email:',
  'pages.settings.email.unbind': 'Not bound',
  'pages.settings.email.bind': 'Bind Email',
  'pages.settings.email.change': 'Change Email',
  'pages.settings.email.modal.title': 'Bind Email',
  'pages.settings.email.modal.changeTitle': 'Change Email',
  'pages.settings.email.form.label': 'Email',
  'pages.settings.email.form.required': 'Please enter email',
  'pages.settings.email.form.invalid': 'Invalid email format',
  'pages.settings.email.bindSuccess': 'Email bound successfully',
  'pages.settings.email.bindFailed': 'Failed to bind email',
  'pages.settings.changePassword.title': 'Change Password',
  'pages.settings.changePassword.button': 'Change Password',
  'pages.settings.changePassword.modal.title': 'Change Password',
  'pages.settings.changePassword.oldPassword.label': 'Old Password',
  'pages.settings.changePassword.oldPassword.required': 'Please enter old password',
  'pages.settings.changePassword.newPassword.label': 'New Password',
  'pages.settings.changePassword.newPassword.required': 'Please enter new password',
  'pages.settings.changePassword.newPassword.min': 'New password must be at least 6 characters',
  'pages.settings.changePassword.confirmPassword.label': 'Confirm New Password',
  'pages.settings.changePassword.confirmPassword.required': 'Please confirm new password',
  'pages.settings.changePassword.confirmPassword.mismatch': 'Passwords do not match',
  'pages.settings.changePassword.success': 'Password changed successfully',
  'pages.settings.changePassword.failed': 'Failed to change password',
  'pages.settings.deleteAccount.title': 'Delete Account',
  'pages.settings.deleteAccount.button': 'Delete Account',
  'pages.settings.deleteAccount.confirm.title': 'Confirm Account Deletion?',
  'pages.settings.deleteAccount.confirm.content': 'This operation cannot be undone. Are you sure you want to delete your account?',
  'pages.settings.deleteAccount.confirm.ok': 'Delete',
  'pages.settings.deleteAccount.confirm.cancel': 'Cancel',
  'pages.settings.deleteAccount.success': 'Account deleted successfully',
  'pages.settings.deleteAccount.failed': 'Failed to delete account',
  'pages.settings.profile.fetchFailed': 'Failed to fetch user information',
  'pages.settings.form.submit': 'Submit',
  'pages.settings.password.title': 'Password Settings',
  'pages.settings.basicInfo.username': 'Username',
  'pages.settings.basicInfo.nickname': 'Nickname',
  'pages.settings.basicInfo.avatar': 'Avatar',
  'pages.settings.basicInfo.editNickname': 'Edit Nickname',
  'pages.settings.basicInfo.editNicknameTitle': 'Edit Title',
  'pages.settings.basicInfo.newNicknameLabel': 'New Nickname',
  'pages.settings.basicInfo.nicknameChangeSuccess': 'Nickname changed successfully',
  'pages.settings.basicInfo.openId': 'OpenID:',
  'pages.settings.submit': 'Submit',
  'pages.settings.deleteAccount.confirmTitle': 'Confirm Account Deletion',
  'pages.settings.deleteAccount.confirmContent': 'After your account is deleted, all your data will be permanently deleted and cannot be recovered, and you will no longer be able to log in. Please proceed with caution.',
  'pages.settings.deleteAccount.cancel': 'Cancel',
  'pages.settings.deleteAccount.confirm': 'Confirm Deletion',

  // Admin Dashboard
  'pages.admin.dashboard.userCount': 'User Count',
  'pages.admin.dashboard.deviceCount': 'Device Count',
  'pages.admin.dashboard.agentCount': 'Agent Count',
  'pages.admin.dashboard.onlineUsers': 'Online Users',
  'pages.admin.dashboard.sessionDevices': 'Session Devices',
  'pages.admin.dashboard.websocketConnections': 'WebSocket Connections',
  'pages.admin.dashboard.mqttConnections': 'MQTT Connections',
  'pages.admin.dashboard.mqttUdpSessions': 'MQTT UDP Sessions',
  'pages.admin.dashboard.devicesInDialogue': 'Devices In Dialogue',
  'pages.admin.dashboard.poolMcp': 'MCP Pool',
  'pages.admin.dashboard.poolAsr': 'ASR Pool',
  'pages.admin.dashboard.poolTts': 'TTS Pool',
  'pages.admin.dashboard.poolUsageHint': 'In use / Max',
  'pages.admin.dashboard.instanceBadge': 'Instance {instanceId} · {role}',
  'pages.admin.dashboard.localInstanceHint': 'This instance',
  'pages.admin.dashboard.redisClusterHint': 'Redis cluster',
  'pages.admin.dashboard.memoryUsage': 'Memory Usage',
  'pages.admin.dashboard.cpuUsage': 'CPU Usage',
  'pages.admin.dashboard.fetchError': 'Failed to fetch data',
  'pages.admin.dashboard.networkError': 'Network Error',
  'pages.admin.dashboard.property': 'Property',
  'pages.admin.dashboard.value': 'Value',
  'pages.admin.dashboard.systemMemory': 'System',
  'pages.admin.dashboard.processMemory': 'Process',
  'pages.admin.dashboard.cpu': 'CPU',
  'pages.admin.dashboard.cpu.cores': 'Core Count',
  'pages.admin.dashboard.cpu.user': 'User Usage',
  'pages.admin.dashboard.cpu.sys': 'System Usage',
  'pages.admin.dashboard.cpu.idle': 'Idle Rate',
  'pages.admin.dashboard.memory': 'Memory',
  'pages.admin.dashboard.memory.total': 'Total Memory',
  'pages.admin.dashboard.memory.used': 'Used Memory',
  'pages.admin.dashboard.memory.free': 'Free Memory',
  'pages.admin.dashboard.memory.usage': 'Usage',
  'pages.admin.dashboard.serverInfo': 'Server Information',
  'pages.admin.dashboard.host.name': 'Hostname',
  'pages.admin.dashboard.host.ip': 'Server IP',
  'pages.admin.dashboard.host.os': 'Operating System',
  'pages.admin.dashboard.host.arch': 'Architecture',
  'pages.admin.dashboard.runtimeInfo': 'Runtime Information',
  'pages.admin.dashboard.runtime.name': 'Runtime Name',
  'pages.admin.dashboard.runtime.version': 'Runtime Version',
  'pages.admin.dashboard.runtime.startTime': 'Start Time',
  'pages.admin.dashboard.runtime.uptime': 'Uptime',
  'pages.admin.dashboard.runtime.projectPath': 'Project Path',
  'pages.admin.dashboard.runtime.executable': 'Executable',
  'pages.admin.dashboard.runtime.goroutines': 'Goroutines',
  'pages.admin.dashboard.runtime.serverVersion': 'Server Version',
  'pages.admin.dashboard.runtime.instanceId': 'Instance ID',
  'pages.admin.dashboard.runtime.role': 'Role',
  'pages.admin.dashboard.runtime.runArgs': 'Run Arguments',
  'pages.admin.dashboard.businessSummary': 'Business Summary',

  // Admin User Management
  'pages.admin.user.id': 'ID',
  'pages.admin.user.username': 'Username',
  'pages.admin.user.phoneNumber': 'Phone',
  'pages.admin.user.email': 'Email',
  'pages.admin.user.status': 'Status',
  'pages.admin.user.status.all': 'All',
  'pages.admin.user.status.disabled': 'Disabled',
  'pages.admin.user.status.normal': 'Normal',
  'pages.admin.user.quotaUsed': 'Daily Quota Used',
  'pages.admin.user.quotaTotal': 'Daily Quota Total',
  'pages.admin.user.createdAt': 'Created At',
  'pages.admin.user.operations': 'Operations',
  'pages.admin.user.edit': 'Edit',
  'pages.admin.user.detail': 'Detail',
  'pages.admin.user.editModal.title': 'Edit User',
  'pages.admin.user.status.label': 'User Status',
  'pages.admin.user.status.enable': 'Enable',
  'pages.admin.user.status.disable': 'Disable',
  'pages.admin.user.quotaUsed.label': 'Used today',
  'pages.admin.user.quotaTotal.label': 'Daily total',
  'pages.admin.user.email.label': 'Email',
  'pages.admin.user.save.success': 'Save successful',
  'pages.admin.user.save.failed': 'Save failed',
  'pages.admin.user.list.title': 'User List',
  'pages.admin.user.create': 'Add User',
  'pages.admin.user.createModal.title': 'Add User',
  'pages.admin.user.create.success': 'Created successfully',
  'pages.admin.user.create.failed': 'Create failed',
  'pages.admin.user.username.label': 'Username',
  'pages.admin.user.username.required': 'Please enter username',
  'pages.admin.user.username.min': 'Username must be at least 2 characters',
  'pages.admin.user.password.label': 'Password',
  'pages.admin.user.password.required': 'Please enter password',
  'pages.admin.user.password.min': 'Password must be at least 6 characters',
  'pages.admin.user.phoneNumber.label': 'Phone',
  'pages.admin.user.phoneNumber.invalid': 'Invalid phone number',
  'pages.admin.user.phoneNumber.placeholder': 'Optional, 11-digit mainland mobile',
  'pages.admin.user.email.invalid': 'Invalid email',
  'pages.admin.user.email.placeholder': 'Optional',
  'pages.admin.user.section.basic': 'Basic',
  'pages.admin.user.section.quota': 'Quota',
  'pages.admin.user.section.knowledgeBase': 'Knowledge Base',
  'pages.admin.user.section.openapi': 'OpenAPI',
  'pages.admin.user.section.security': 'Security',
  'pages.admin.user.newPassword.extra': 'Leave blank to keep current password',
  'pages.admin.user.newPassword.placeholder': 'Optional',
  'pages.admin.user.knowledgeBaseEnabled.label': 'Enabled',
  'pages.admin.user.knowledgeBaseMaxCount.label': 'Max KBs',
  'pages.admin.user.knowledgeBaseDocMaxCount.label': 'Max docs / KB',
  'pages.admin.user.knowledgeBaseMaxCount.tooltip': 'Effective limit is the smaller of user and system settings',
  'pages.admin.user.knowledgeBaseDocMaxCount.tooltip': 'Effective limit is the smaller of user and system settings',

  // Admin Model Providers
  'pages.admin.providers.title': 'Model Provider Management',
  'pages.admin.providers.total': 'Total {total} providers',
  'pages.admin.providers.stats': 'ASR: {asr}, TTS: {tts}, LLM: {llm}, VLLLM: {vlllm}',
  'pages.admin.providers.statsTotal': '{n} providers total',
  'pages.admin.providers.loading': 'Loading model providers…',
  'pages.admin.providers.addNew': 'Add New Provider',
  'pages.admin.providers.search.placeholder': 'Search provider name, endpoint or model...',
  'pages.admin.providers.filter.all': 'All Types',
  'pages.admin.providers.filter.asr': 'ASR - Speech Recognition',
  'pages.admin.providers.filter.tts': 'TTS - Text to Speech',
  'pages.admin.providers.filter.llm': 'LLM - Large Language Model',
  'pages.admin.providers.filter.vlllm': 'VLLLM - Vision Language Model',
  'pages.admin.providers.empty.noProviders': 'No providers yet',
  'pages.admin.providers.empty.noMatches': 'No matching providers found',
  'pages.admin.providers.empty.addFirst': 'Click the button above to add your first model provider',
  'pages.admin.providers.empty.adjustFilters': 'Try adjusting search criteria or filters',
  'pages.admin.providers.type.asr': 'ASR - Speech Recognition',
  'pages.admin.providers.type.tts': 'TTS - Text to Speech',
  'pages.admin.providers.type.llm': 'LLM - Large Language Model',
  'pages.admin.providers.type.vlllm': 'VLLLM - Vision Language Model',
  'pages.admin.providers.success.created': 'Provider added successfully!',
  'pages.admin.providers.success.updated': 'Provider updated successfully!',
  'pages.admin.providers.success.deleted': 'Provider deleted successfully!',
  'pages.admin.providers.success.statusToggled': 'Status toggled successfully!',
  'pages.admin.providers.error.createFailed': 'Failed to add provider, please try again',
  'pages.admin.providers.error.updateFailed': 'Failed to update provider, please try again',
  'pages.admin.providers.error.deleteFailed': 'Failed to delete provider, please try again',
  'pages.admin.providers.error.testFailed': 'Connection test failed, please check network or configuration',
  'pages.admin.providers.error.toggleFailed': 'Failed to toggle status, please try again',
  'pages.admin.providers.error.loadFailed': 'Failed to load provider list, please refresh the page',

  // Admin Settings
  'pages.admin.settings.title': 'System Settings',
  'pages.admin.settings.asr.label': 'ASR Service',
  'pages.admin.settings.asr.placeholder': 'Select ASR Service',
  'pages.admin.settings.tts.label': 'TTS Service',
  'pages.admin.settings.tts.placeholder': 'Select TTS Service',
  'pages.admin.settings.llm.label': 'LLM Service',
  'pages.admin.settings.llm.placeholder': 'Select LLM Service',
  'pages.admin.settings.vlllm.label': 'VLLLM Service',
  'pages.admin.settings.vlllm.placeholder': 'Select VLLLM Service',
  'pages.admin.settings.prompt.label': 'Prompt Settings (Default Role)',
  'pages.admin.settings.prompt.placeholder': 'Please enter system prompt...',
  'pages.admin.settings.middleTierRole.label': 'Middle-tier Prompt Settings',
  'pages.admin.settings.middleTierRole.placeholder': 'Please enter middle-tier prompt...',
  'pages.admin.settings.visionPrompt.label': 'VLLM prompt settings',
  'pages.admin.settings.visionPrompt.placeholder': 'Please enter VLLM prompt...',
  'pages.admin.settings.quickReply.label': 'Quick Reply Words',
  'pages.admin.settings.quickReply.placeholder': 'Enter new quick reply word',
  'pages.admin.settings.quickReply.add': 'Add',
  'pages.admin.settings.deleteAudio.label': 'Delete Audio',
  'pages.admin.settings.deleteAudio.enabled': 'Enabled',
  'pages.admin.settings.deleteAudio.disabled': 'Disabled',
  'pages.admin.settings.usePrivateConfig': 'Use Private Config',
  'pages.admin.settings.save': 'Save Configuration',
  'pages.admin.settings.saving': 'Saving...',
  'pages.admin.settings.reset': 'Reset',
  'pages.admin.settings.success.saved': 'Configuration saved successfully!',
  'pages.admin.settings.error.saveFailed': 'Failed to save configuration, please try again',
  'pages.admin.settings.error.loadFailed': 'Failed to load configuration, please refresh the page and try again',

  // Add Device Dialog
  'pages.addDevice.modal.title': 'Add Device',
  'pages.addDevice.verificationCode.label': 'Verification Code:',
  'pages.addDevice.verificationCode.placeholder': 'Please enter the 6-digit verification code from device',
  'pages.addDevice.verificationCode.required': 'Please enter a 6-digit verification code',
  'pages.addDevice.verificationCode.error': 'Please enter a 6-digit verification code',

  // Provider Modal
  'pages.admin.providerModal.edit.title': 'Edit Provider',
  'pages.admin.providerModal.add.title': 'Add New Provider',
  'pages.admin.providerModal.name.label': 'Provider Name *',
  'pages.admin.providerModal.name.placeholder': 'e.g.: OpenAI, Doubao TTS',
  'pages.admin.providerModal.name.required': 'Please enter provider name',
  'pages.admin.providerModal.validation.failed': 'Please fix required fields or invalid configuration (see errors below fields).',
  'pages.admin.providerModal.type.label': 'Service Category *',
  'pages.admin.providerModal.subType.label': 'Specific Type *',
  'pages.admin.providerModal.subType.required': 'Please select specific type',
  'pages.admin.providerModal.config.title': 'Configuration',
  'pages.admin.providerModal.api.url.label': 'API URL *',
  'pages.admin.providerModal.api.url.required': 'Please enter API URL',
  'pages.admin.providerModal.model.name.label': 'Model Name *',
  'pages.admin.providerModal.model.name.required': 'Please enter model name',
  'pages.admin.providerModal.model.label': 'Model *',
  'pages.admin.providerModal.model.required': 'Please enter model',
  'pages.admin.providerModal.api.key.label': 'API Key *',
  'pages.admin.providerModal.api.key.required': 'Please enter API key',
  'pages.admin.providerModal.temperature.label': 'Temperature (0-2)',
  'pages.admin.providerModal.temperature.error': 'Temperature should be between 0-2',
  'pages.admin.providerModal.maxTokens.label': 'Max Tokens',
  'pages.admin.providerModal.maxTokens.error': 'Max tokens should be between 1-32768',
  'pages.admin.providerModal.maxTokens.gtWindow': 'max_tokens (output) must not exceed context_window (total capacity)',
  'pages.admin.providerModal.contextWindow.label': 'Context window (context_window)',
  'pages.admin.providerModal.contextWindow.help': 'Model context window in tokens: persona + history + tools + reply. Fill from the official model docs; 0 means unknown and the server infers a tier from the model name. Used only for budget math, never sent to the model. context_window is total capacity; max_tokens is the reply share.',
  'pages.admin.providerModal.contextWindow.preset': 'Quick presets',
  'pages.admin.providerModal.contextWindow.hint': 'context_window = total capacity (registry only); max_tokens = reply share. 0 infers a tier from the model name.',
  'pages.admin.providerModal.contextWindow.budget': 'Estimated input budget at default 70% (actual ratio comes from system config, then minus max_tokens) ≈',
  'pages.admin.providerModal.contextWindow.error': 'Context window cannot be negative',
  'pages.admin.providerModal.topP.label': 'Top-P',
  'pages.admin.providerModal.appid.label': 'App ID *',
  'pages.admin.providerModal.appid.required': 'Please enter App ID',
  'pages.admin.providerModal.qwen.workspaceId.label': 'App ID (Workspace ID)',
  'pages.admin.providerModal.qwen.workspaceId.placeholder': 'llm-xxx (optional, DashScope workspace ID)',
  'pages.admin.providerModal.accessToken.label': 'Access Token *',
  'pages.admin.providerModal.accessToken.required': 'Please enter access token',
  'pages.admin.providerModal.cluster.label': 'Cluster',
  'pages.admin.providerModal.grpc.host.label': 'gRPC Host *',
  'pages.admin.providerModal.grpc.host.required': 'Please enter gRPC host address',
  'pages.admin.providerModal.grpc.port.label': 'gRPC Port *',
  'pages.admin.providerModal.grpc.port.required': 'Please enter gRPC port',
  'pages.admin.providerModal.grpc.addr.label': 'gRPC Address (host:port) *',
  'pages.admin.providerModal.grpc.addr.required': 'Please enter gRPC address (host:port)',
  'pages.admin.providerModal.voice.label': 'Voice *',
  'pages.admin.providerModal.voice.required': 'Please enter voice type',
  'pages.admin.providerModal.token.label': 'Token *',
  'pages.admin.providerModal.token.required': 'Please enter token',
  'pages.admin.providerModal.websocket.label': 'WebSocket URL *',
  'pages.admin.providerModal.websocket.required': 'Please enter WebSocket URL',
  'pages.admin.providerModal.siliconflow.apiKey.label': 'API Key *',
  'pages.admin.providerModal.siliconflow.apiKey.required': 'Please enter API key',
  'pages.admin.providerModal.siliconflow.baseUrl.label': 'API URL',
  'pages.admin.providerModal.outputDir.label': 'Output Directory',
  'pages.admin.providerModal.manage.voices': 'Manage Voices',
  'pages.admin.providerModal.edge.noConfig': 'Microsoft Edge TTS requires no additional configuration',
  'pages.admin.providerModal.submit.error': 'Submit failed, please try again',
  'pages.admin.providerModal.copyAsNew': 'Copy as New Provider',

  // Provider Card
  'pages.admin.providerCard.status.active': 'Active',
  'pages.admin.providerCard.status.inactive': 'Offline',
  'pages.admin.providerCard.status.error': 'Error',
  'pages.admin.providerCard.status.unknown': 'Unknown',
  'pages.admin.providerCard.warning.readonly.test': 'Read-only permission, cannot test provider',
  'pages.admin.providerCard.warning.readonly.delete': 'Read-only permission, cannot delete provider',
  'pages.admin.providerCard.warning.readonly.edit': 'Read-only permission, cannot edit provider',
  'pages.admin.providerCard.warning.readonly.toggle': 'Read-only permission, cannot toggle status',
  'pages.admin.providerCard.button.disable': 'Disable',
  'pages.admin.providerCard.button.enable': 'Enable',
  'pages.admin.providerCard.button.testing': 'Testing...',
  'pages.admin.providerCard.button.test': 'Test',
  'pages.admin.providerCard.button.edit': 'Edit',
  'pages.admin.providerCard.button.delete': 'Delete',
  'pages.admin.providerCard.delete.title': 'Are you sure you want to delete this item?',
  'pages.admin.providerCard.delete.content': 'It cannot be recovered after deletion, please confirm the operation.',
  'pages.admin.providerCard.config.type': 'Type',
  'pages.admin.providerCard.config.apiUrl': 'API URL',
  'pages.admin.providerCard.config.model': 'Model',
  'pages.admin.providerCard.config.apiKey': 'API Key',
  'pages.admin.providerCard.config.temperature': 'Temperature',
  'pages.admin.providerCard.config.maxTokens': 'Max Tokens',
  'pages.admin.providerCard.config.contextWindow': 'Context window',
  'pages.admin.providerCard.config.appid': 'App ID',
  'pages.admin.providerCard.config.workspaceId': 'App ID',
  'pages.admin.providerCard.config.cluster': 'Cluster',
  'pages.admin.providerCard.config.accessToken': 'Access Token',
  'pages.admin.providerCard.config.grpcHost': 'gRPC Host',
  'pages.admin.providerCard.config.grpcPort': 'gRPC Port',
  'pages.admin.providerCard.config.voice': 'Voice',
  'pages.admin.providerCard.config.format': 'Format',
  'pages.admin.providerCard.config.token': 'Token',
  'pages.admin.providerCard.config.outputDir': 'Output Directory',
  'pages.admin.providerCard.voices.supported': 'Supported Voices',
  'pages.admin.providerCard.voices.count': '',
  'pages.admin.providerCard.voices.more': ', {n} total',
  'pages.admin.providerCard.test.failed': 'Test failed',

  // OpsManage
  'pages.admin.ops.service.title': 'Service Management',
  'pages.admin.ops.upload.button': 'Upload Service File',
  'pages.admin.ops.upload.success': 'Service file uploaded successfully',
  'pages.admin.ops.upload.error': 'Service file upload failed',
  'pages.admin.ops.restart.button': 'Restart Service',
  'pages.admin.ops.restart.confirmTitle': 'Caution: Are you sure you want to restart the service?',
  'pages.admin.ops.restart.desc': 'Restarting the service will disconnect all current connections and make the service temporarily unavailable.',
  'pages.admin.ops.restart.warn': 'This operation will only stop the current service process. Please ensure a daemon or auto-restart script is configured on the server, otherwise the service will not recover automatically!',
  'pages.admin.ops.restart.ok': 'Confirm Restart',
  'pages.admin.ops.restart.cancel': 'Cancel',
  'pages.admin.ops.restart.success': 'Service restart command sent',
  'pages.admin.ops.restart.error': 'Service restart failed',
  'pages.admin.ops.log.title': 'Log View & Download',
  'pages.admin.ops.web.upload.button': 'Upload web.zip',
  'pages.admin.ops.web.upload.success': 'web.zip uploaded successfully',
  'pages.admin.ops.web.upload.error': 'web.zip upload failed',
  'pages.admin.ops.web.upload.onlyzip': 'Only zip files are allowed',
  'pages.admin.ops.web.update.button': 'Update web directory',
  'pages.admin.ops.web.update.success': 'Web directory update command sent',
  'pages.admin.ops.web.update.error': 'Web directory update failed',
  'pages.admin.ops.web.upload.onlywebzip': 'Only a file named web.zip is allowed',

  // Recorder Management
  'pages.admin.recorder.title': 'Device Recorder Management',
  'pages.admin.settings.voiceCloneEnable': 'Enable Voice Clone',
  'pages.admin.settings.voiceClone.placeholder': 'Voice clone service',
  'pages.admin.recorder.inputDeviceId': 'Please enter device ID',
  'pages.admin.recorder.inputPlaceholder': 'Please enter device ID',
  'pages.admin.recorder.search': 'Search',
  'pages.admin.recorder.list.title': 'Recorder List',
  'pages.admin.recorder.fetchSuccess': 'Successfully retrieved recorder records',
  'pages.admin.recorder.fetchError': 'Failed to retrieve recorder list',
  'pages.admin.recorder.empty': 'No recorder data, please enter device ID to search',
  'pages.admin.recorder.totalCount': 'Statistics',
  'pages.admin.recorder.conversationId': 'Conversation ID',

  //contractDevice
  'pages.contractDevice.cardTitle': 'Contract Device Management',
  'pages.contractDevice.mac': 'MAC Address',
  'pages.contractDevice.protocolType': 'Protocol Type',
  'pages.contractDevice.status': 'Status',
  'pages.contractDevice.expireTime': 'Expiration Time',
  'pages.contractDevice.updateTime': 'Update Time',
  'pages.contractDevice.operations': 'Actions',
  'pages.contractDevice.edit': 'Edit',
  'pages.contractDevice.delete': 'Delete',
  'pages.contractDevice.deleteConfirm': 'Confirm Delete',
  'pages.contractDevice.addTitle': 'Add Contract Device',
  'pages.contractDevice.batchAddTitle': 'Batch Add',
  'pages.contractDevice.editTitle': 'Edit Contract Device',
  'pages.contractDevice.listTitle': 'Contract Device List',
  'pages.contractDevice.add': 'Add',
  'pages.contractDevice.batchAdd': 'Batch Add',
  'pages.contractDevice.selectCsvTip': 'Please select a CSV file',
  'pages.contractDevice.uploadSuccess': 'Upload successful',
  'pages.contractDevice.macRequired': 'Please enter MAC address',
  'pages.contractDevice.protocolTypeRequired': 'Please select protocol type',
  'pages.contractDevice.statusRequired': 'Please select status',
  'pages.contractDevice.expireTimeRequired': 'Please select expiration time',

  'pages.agentSetting.mcp.modal.title': 'MCP Endpoint Settings',
  'pages.agentSetting.mcp.modal.statusLabel': 'Endpoint Status',
  'pages.agentSetting.mcp.modal.online': 'Online',
  'pages.agentSetting.mcp.modal.disconnected': 'Disconnected',
  'pages.agentSetting.mcp.modal.unknown': 'Unknown',
  'pages.agentSetting.mcp.modal.refresh': 'Refresh',
  'pages.agentSetting.mcp.modal.enabledServices': 'Enabled Services',
  'pages.agentSetting.mcp.modal.endpointLabel': 'Endpoint Address',
  'pages.agentSetting.mcp.modal.endpointDesc': 'Below is the MCP endpoint address for the agent.',
  'pages.agentSetting.mcp.modal.docLink': 'View Endpoint Documentation',
  'pages.agentSetting.mcp.modal.noEndpoint': 'No available endpoint',
  'pages.agentSetting.mcp.modal.hide': 'Hide',
  'pages.agentSetting.mcp.title': 'MCP Settings',
  'pages.agentSetting.mcp.customService': 'Custom Service',
  'pages.agentSetting.mcp.officialServices': 'Official Services',
  'pages.agentSetting.mcp.officialServices.placeholder': 'Select official services',
  'pages.agentSetting.mcp.services.weather': 'Weather',
  'pages.agentSetting.mcp.services.joke': 'Joke',
  'pages.agentSetting.mcp.services.music': 'Music',
  'pages.agentSetting.mcp.services.news': 'News',
  'pages.agentSetting.knowledgeBase.label': 'Knowledge Base',
  'pages.agentSetting.knowledgeBase.none': 'None',
  'pages.agentSetting.knowledgeBase.placeholder': 'Select knowledge base',
  'pages.agentSetting.knowledgeBase.config': 'Configure',
  'pages.agentSetting.mcp.error.missingId': 'Missing agent id, cannot retrieve endpoint',
  'pages.agentSetting.mcp.error.noEndpoint': 'Failed to retrieve endpoint from server',
'pages.agentSetting.mcp.error.fetchFailed': 'Failed to retrieve endpoint',
  'pages.agentSetting.mcp.button.getEndpoint': 'Get MCP Endpoint',

  // Memory settings
  'pages.agentSetting.memory.title': 'Short-term Memory',
  'pages.agentSetting.memory.type.label': 'Memory Type',
  'pages.agentSetting.memory.type.none': 'No Memory',
  'pages.agentSetting.memory.type.shortTerm': 'Short-term Memory',
  'pages.agentSetting.memory.current.label.short': 'Current Memory',
  'pages.agentSetting.memory.current.help': 'Regenerated after each conversation',
  'pages.agentSetting.memory.clear': 'Clear Memory',
  'pages.agentSetting.memory.clear.tip': 'Memory marked for clearing, click save to apply',
  'pages.agentSetting.memory.content.label': 'Memory Content',
  'pages.agentSetting.memory.content.placeholder': 'Get latest short-term memory content',
  'pages.agentSetting.memory.content.editPlaceholder': 'Please enter memory content',
  'pages.agentSetting.memory.edit': 'Edit Memory',
  'pages.agentSetting.memory.edit.success': 'Memory updated, please save to apply',
  'pages.agentSetting.memory.edit.save': 'Save Changes',
  'pages.agentSetting.memory.edit.cancel': 'Cancel',

  // Common buttons and actions
  'pages.common.cancel': 'Cancel',

  // System Configuration
  'pages.admin.systemConfig.roleName': 'Role Name',
  'pages.admin.systemConfig.roleDesc': 'Role Description',
  'pages.admin.systemConfig.enabled': 'Enabled Status',
  'pages.admin.systemConfig.featureName': 'Feature Name',
  'pages.admin.systemConfig.featureDesc': 'Feature Description',
  'pages.admin.systemConfig.exitCommand': 'Exit Command',
  'pages.admin.systemConfig.mcpName': 'MCP Name',
  'pages.admin.systemConfig.newNameOptional': 'New Name (Optional)',
  'pages.admin.systemConfig.configJson': 'Config JSON',
  'pages.admin.systemConfig.useDeviceCode': 'Use Device Code',
  'pages.admin.systemConfig.quickReply': 'Quick Reply',
  'pages.admin.systemConfig.shortTermMemory': 'Short Term Memory',
  'pages.admin.systemConfig.saveUserAudio': 'Save User Audio Files',
  'pages.admin.systemConfig.enableWhiteList': 'Enable White List',
  'pages.admin.systemConfig.enhancedEmotionOutput': 'Enhanced Emotion Output',
  'pages.admin.systemConfig.speakerDetect': 'Speaker Recognition',
  'pages.admin.systemConfig.dialogGuardSection': 'Dialog Interruption Guard',
  'pages.admin.systemConfig.dialogGuardPipelineTitle': 'Layer roles & recommended settings (hover ? on each switch)',
  'pages.admin.systemConfig.dialogGuardEnabled': 'Guard master switch',
  'pages.admin.systemConfig.textHardRulesEnabled': 'Text hard rules (L1)',
  'pages.admin.systemConfig.speakerGuardEnabled': 'Speaker hard gate (L2)',
  'pages.admin.systemConfig.speakerHotReloadEnabled': 'Speaker hot reload',
  'pages.admin.systemConfig.speakerQualityCheck': 'Speaker enrollment quality check',
  'pages.admin.systemConfig.speakerLockTtlSec': 'Lock TTL (sec)',
  'pages.admin.systemConfig.speakerLockTtlAfterTtsSec': 'Post-TTS lock (sec)',
  'pages.admin.systemConfig.speakerSwitchConfirmRounds': 'Switch confirm rounds',
  'pages.admin.systemConfig.dialogGuardStats': 'Guard metrics (per process, reset on restart)',
  'pages.admin.systemConfig.dialogGuardStatsDetail': 'Text skip {skipText} · Speaker skip {skipSpeaker} · Context skip {skipContext} · Echo skip {echoSkip} · No-reply {noReply} · No-reply late {noReplyLate} · High switch {switchHigh} · Confirm switch {switchConfirm} · Suspect false block {suspect} · Quality reject {qualityReject}',
  'pages.admin.systemConfig.intentReplySection': 'Reply intent enhancements (hot reload)',
  'pages.admin.systemConfig.intentReplyHotReloadHint': 'L2.5 / L3 below take effect immediately after save (no restart). Requires the dialog-guard master switch above.',
  'pages.admin.systemConfig.intentReplyRelationHint': 'Relation: L2.5 = cheap hard gate before main chat; L3 = dialog.no_reply inside main chat. Recommended: enable both and keep “inject only when no speaker” OFF so gray cases go to the model. When debugging silence, search logs for dialog_guard SKIP: layer=L2.5 is hard skip, layer=L3 is model decline.',
  'pages.admin.systemConfig.intentMergeEnabled': 'Main dialog L3 (dialog.no_reply)',
  'pages.admin.systemConfig.intentMergeOnlyNoSpeaker': 'Inject only when no speaker',
  'pages.admin.systemConfig.intentMergePrompt': 'No-reply prompt',
  'pages.admin.systemConfig.intentMergePromptPlaceholder': 'Server default prompt',
  'pages.admin.systemConfig.contextGateEnabled': 'Context hard rules (L2.5)',
  'pages.admin.systemConfig.contextGateRecentTurns': 'Continuation lookback turns',
  'pages.admin.systemConfig.contextGateShortCjk': 'CJK short-utterance char threshold',
  'pages.admin.systemConfig.contextGateShortLatin': 'Latin short-utterance word threshold',
  // L4 Standalone classifier (unused, commented out)
  // 'pages.admin.systemConfig.intentStandaloneEnabled': 'Standalone classifier (L4)',
  // 'pages.admin.systemConfig.intentStandaloneMode': 'Standalone trigger mode',
  // 'pages.admin.systemConfig.intentStandaloneMode.noSpeaker': 'No speaker only',
  // 'pages.admin.systemConfig.intentStandaloneMode.unlocked': 'Unlocked only',
  // 'pages.admin.systemConfig.intentStandaloneMode.alwaysGray': 'All gray area',
  // 'pages.admin.systemConfig.intentStandaloneHttpUrl': 'Standalone HTTP URL',
  // 'pages.admin.systemConfig.intentStandaloneTimeoutMs': 'Standalone timeout (ms)',
  // 'pages.admin.systemConfig.intentStandaloneMinConfidence': 'Standalone min confidence',
  'pages.admin.systemConfig.recorderManagerEnable': 'Enable Recorder Management',
  'pages.admin.systemConfig.voiceCloneEnable': 'Enable Voice Clone',
  'pages.admin.systemConfig.flattenedChatHistory': 'Flattened Chat History',
  'pages.admin.systemConfig.dialogueHistoryLength': 'Dialogue History Length',
  'pages.admin.systemConfig.userTotalQuota': 'User Total Quota',
  'pages.admin.systemConfig.dailyClearQuota': 'Daily Clear Quota',
  'pages.admin.systemConfig.checkDeviceModeImmediately': 'Check Device Mode Immediately',
  'pages.admin.systemConfig.defaultObserverUserOnRegister': 'Default Observer User on Register',
  'pages.admin.systemConfig.status': 'Status',
  'pages.admin.systemConfig.port': 'Port',
  'pages.admin.systemConfig.udpShowPort': 'Show Port',
  'pages.admin.systemConfig.accessToken': 'Access Token',
  'pages.admin.systemConfig.activateText': 'Activate Text',
  'pages.admin.systemConfig.logLevel': 'Log Level',
  'pages.admin.systemConfig.logDir': 'Log Directory',
  'pages.admin.systemConfig.logFileName': 'Log File Name',

  // Voice Clone
  'pages.console.voiceClone.name': 'Name',
  'pages.console.voiceClone.provider': 'Provider',
  'pages.console.voiceClone.mode': 'Mode',
  'pages.console.voiceClone.record': 'Record',
  'pages.console.voiceClone.upload': 'Upload',

  // Speakers
  'pages.console.speakers.name': 'Name',
  'pages.console.speakers.mode': 'Mode',
  'pages.console.speakers.record': 'Record',
  'pages.console.speakers.upload': 'Upload',
  'pages.console.speakers.pageTip': 'Each speaker requires all 3 fixed sentences; online devices pick it up via hot reload without reconnecting.',
  'pages.console.speakers.recordTip': 'All 3 fixed sentences are required. Speak each for 2.5–3.5 s with a 0.5 s pause between; same device/microphone, 20–30 cm away, quiet environment, normal volume.',

  // Settings
  'pages.console.settings.email': 'Email',
  'pages.console.settings.oldPassword': 'Old Password',
  'pages.console.settings.newPassword': 'New Password',
  'pages.console.settings.confirmNewPassword': 'Confirm New Password',

  // VLLM Provider
  'pages.providers.vllm.maxPixels': 'Max Pixels',

  'pages.unbindDevice.cardTitle': 'Unbind Device',
  'pages.whiteList.cardTitle': 'Whitelist Management',
  'pages.admin.feedback.title': 'Feedback Management',
  'pages.admin.feedback.id': 'ID',
  'pages.admin.feedback.userId': 'User ID',
  'pages.admin.feedback.faultType': 'Issue Type',
  'pages.admin.feedback.faultType.offline': 'Device offline/cannot connect',
  'pages.admin.feedback.faultType.hardware': 'Hardware damage/appearance broken',
  'pages.admin.feedback.faultType.function': 'Function abnormal/no response',
  'pages.admin.feedback.faultType.firmware': 'Firmware upgrade failed',
  'pages.admin.feedback.faultType.other': 'Other issues',
  'pages.admin.feedback.problemDesc': 'Description',
  'pages.admin.feedback.deviceModel': 'Device Model',
  'pages.admin.feedback.deviceMac': 'Device MAC',
  'pages.admin.feedback.contact': 'Contact',
  'pages.admin.feedback.email': 'Email',
  'pages.admin.feedback.phone': 'Phone',
  'pages.admin.feedback.isSolved': 'Status',
  'pages.admin.feedback.isSolved.pending': 'Pending',
  'pages.admin.feedback.isSolved.solved': 'Solved',
  'pages.admin.feedback.createTime': 'Submitted At',
  'pages.admin.feedback.updateTime': 'Updated At',
  'pages.admin.feedback.operations': 'Actions',
  'pages.admin.feedback.detail': 'Detail',
  'pages.admin.feedback.detail.title': 'Feedback Detail',
  'pages.admin.feedback.markSolved': 'Mark as Solved',
  'pages.admin.feedback.markPending': 'Mark as Pending',
  'pages.admin.feedback.process.success': 'Status updated',
  'pages.admin.feedback.process.failed': 'Update failed',
  'pages.admin.feedback.delete': 'Delete',
  'pages.admin.feedback.delete.confirm': 'Delete this feedback?',
  'pages.admin.feedback.delete.success': 'Deleted successfully',
  'pages.admin.feedback.delete.failed': 'Delete failed',

  'pages.admin.devices': 'Device Management',
  'pages.admin.unbindDevice': 'Unbind Device',
  'pages.admin.deviceManage': 'Device Management',
  'pages.systemConfig.quickReply': 'Quick Reply',
  'pages.systemConfig.useShortTermMemory': 'Short Term Memory',
  'pages.systemConfig.useShortTermMemory.desc': 'When enabled, the system uses short-term memory mechanism to update short-term memory after each round of dialogue. When disabled, short-term memory is not used.',
  'pages.agentSetting.mcp.modal.show': 'Show',
  'pages.agentSetting.mcp.modal.copied': 'Copied',
  'pages.agentSetting.mcp.modal.copy': 'Copy',
  'pages.admin.providerModal.model.placeholder': 'Please enter model name',
  'pages.admin.providerModal.security.title': 'Security Settings',
  'pages.admin.providerModal.appid.placeholder': 'Doubao App ID',
  'pages.admin.providerModal.accessToken.placeholder': 'Access Token',
  'pages.admin.providerModal.token.placeholder': 'Doubao Token',
  'pages.admin.providerModal.siliconflow.apiKey.placeholder': 'API Key',
  'pages.admin.providerModal.manageVoices': 'Manage Voices',
  'pages.admin.whiteList.inputMac': 'Please enter MAC address',
  'pages.admin.whiteList.batchAdd': 'Batch Add',
  'pages.admin.whiteList.add': 'Add',
  'pages.admin.whiteList.list.title': 'MAC Address List',
  'pages.admin.whiteList.selectCsvTip': 'Please select a CSV file',
  'pages.admin.whiteList.uploadSuccess': 'Upload Success',
  'pages.admin.whiteList.uploadFailed': 'Upload Failed',
  'pages.admin.whiteList.invalidMac': 'Please enter a valid MAC address',
  'pages.agentSetting.roleTemplate.empty': 'No template available, please check role_template.json',
  'pages.admin.providerModal.save': 'Save',

  // Products
  'pages.products.search.placeholder': 'Search products',
  'pages.products.create.button': 'Create Product',
  'pages.products.sort.id': 'Sort by ID',
  'pages.products.sort.updatedAt': 'Sort by Recently Modified',
  'pages.products.sort.lastConversationAt': 'Sort by Recent Conversation',
  'pages.products.search.button': 'Search',
  'pages.products.create.modal.title': 'Create Product',
  'pages.products.create.modal.nameLabel': 'Product Name',
  'pages.products.create.modal.descriptionLabel': 'Product Description',
  'pages.products.create.modal.codecTypeLabel': 'Codec Type',
  'pages.products.create.modal.voiceEnabledLabel': 'Support Voice',
  'pages.products.create.modal.productKeyLabel': 'Product Key',
  'pages.products.create.modal.deviceTypeLabel': 'Device Type',
  'pages.products.create.modal.locationTypeLabel': 'Location Type',
  'pages.products.create.modal.netTypeLabel': 'Network Type',
  'pages.products.create.modal.imageLabel': 'Product Image',
  'pages.products.create.success': 'Product created successfully',
  'pages.products.create.failed': 'Failed to create product',
  'pages.uploadImage.upload': 'Upload Image',

  // RoleTemplate page related text
  'pages.roleTemplate.modal.title': 'Role Template',
  'pages.roleTemplate.add': 'Add Role Template',
  'pages.roleTemplate.nameRequired': 'Please enter name',
  'pages.roleTemplate.categoryRequired': 'Please enter category',
  'pages.roleTemplate.promptRequired': 'Please enter role introduction',
  'pages.roleTemplate.voiceRequired': 'Please enter voice',
  'pages.roleTemplate.voiceNameRequired': 'Please enter voice name',
  'pages.roleTemplate.message.Success': 'Save successful',
  'pages.roleTemplate.presets.label': 'Multilingual preset intros',
  'pages.roleTemplate.presets.download': 'Download import template',
  'pages.roleTemplate.presets.import': 'Bulk import',
  'pages.roleTemplate.presets.importPreview': 'Import preview',
  'pages.roleTemplate.presets.confirmImport': 'Confirm import',
  'pages.roleTemplate.presets.fillLanguagePrompt': 'Please fill in the role intro for this language',
  'pages.roleTemplate.presets.editingHintSame': 'Editing: {lang} (also the primary dialog language)',
  'pages.roleTemplate.presets.editingHintDiff': 'Editing: {editing} (primary dialog language remains {main})',
  'pages.roleTemplate.presets.needSaveFirst': 'Save the template first before import',
  'pages.roleTemplate.presets.downloadFail': 'Failed to download import template',
  'pages.roleTemplate.presets.saveWarn': 'Template saved, but multilingual presets failed; please edit and save again',
  'pages.roleTemplate.presets.importDone': 'Import done: {imported} ok, {skipped} skipped',
  'pages.roleTemplate.presets.col.row': 'Row',
  'pages.roleTemplate.presets.col.language': 'Language',
  'pages.roleTemplate.presets.col.status': 'Status',
  'pages.roleTemplate.presets.col.summary': 'Summary',
  'pages.roleTemplate.presets.col.message': 'Note',
  'pages.roleTemplate.presets.col.action': 'Action',
  'pages.roleTemplate.presets.removeRow': 'Remove',
  'pages.roleTemplate.presets.nothingToImport': 'No rows to import (remove error rows or re-upload)',
  'pages.roleTemplate.presets.status.create': 'Create',
  'pages.roleTemplate.presets.status.update': 'Update',
  'pages.roleTemplate.presets.status.error': 'Error',
  'pages.roleTemplate.confirm.Delete': 'Are you sure you want to delete this role template?',
  'pages.roleTemplate.column.ID': 'ID',
  'pages.roleTemplate.column.Name': 'Name',
  'pages.roleTemplate.column.Description': 'Description',
  'pages.roleTemplate.column.Category': 'Category',
  'pages.roleTemplate.column.ASR': 'Speech Recognition',
  'pages.roleTemplate.column.LLM': 'LLM',
  'pages.roleTemplate.column.TTS': 'Speech Synthesis Model',
  'pages.roleTemplate.column.Sort': 'Sort',
  'pages.roleTemplate.column.Prompt': 'Role Introduction',
  'pages.roleTemplate.column.Voice': 'Voice',
  'pages.roleTemplate.column.VoiceName': 'Voice Name',
  'pages.roleTemplate.column.UpdatedAt': 'Updated At',
  'pages.roleTemplate.column.CreatedAt': 'Created At',
  'pages.roleTemplate.column.Operation': 'Operation',
  'pages.roleTemplate.column.Model': 'Model Management',
  'pages.roleTemplate.column.voice': 'Voice',
  'pages.roleTemplate.column.voiceName': 'Voice Name',
  'pages.roleTemplate.column.category': 'Category',
  'pages.roleTemplate.column.prompt': 'Role Description',
  'pages.roleTemplate.column.Avatar': 'Avatar',
  'pages.roleTemplate.column.Language': 'Language',
  'pages.roleTemplate.column.asrSpeed': 'Speech Recognition Speed',
  'pages.roleTemplate.column.speakSpeed': 'Speaking Speed',
  'pages.roleTemplate.column.tone': 'Tone',
  'pages.roleTemplate.column.ProductFlag': 'Product Flag',
  'pages.roleTemplate.column.tenantCode': 'Partner tenant',
  'pages.roleTemplate.column.tenantCodeTip': 'Leave empty for platform-wide templates; partner accounts get supplier_code set by the server on create',

  // ProductCategory page related text
  'pages.productCategory.modal.title': 'Product Category',
  'pages.productCategory.add': 'Add Category',
  'pages.productCategory.column.Name': 'Name',
  'pages.productCategory.column.roleTplId': 'Role template ID',
  'pages.productCategory.column.roleTplName': 'Role template name',
  'pages.productCategory.column.roleTplId.placeholder': 'Select role template',
  'pages.productCategory.column.roleTplName.placeholder': 'Enter role template name',
  'pages.productCategory.column.ProductCategory': 'Device model',
  'pages.productCategory.column.Description': 'Description',
  'pages.productCategory.column.status': 'Status',
  'pages.productCategory.column.sort': 'Sort',
  'pages.productCategory.column.updatedAt': 'Updated Time',
  'pages.productCategory.column.CreatedAt': 'Created Time',
  'pages.productCategory.column.Operation': 'Operation',
  'pages.productCategory.action.productionTokenManage': 'Production burn tokens',
  'pages.productCategory.action.firmwareManage': 'Product firmware',
  'pages.productCategory.firmware.drawerTitle': 'Product firmware',
  'pages.productCategory.firmware.categoryLabel': 'Category',
  'pages.productCategory.firmware.boardLabel': 'Board type',
  'pages.productCategory.firmware.noBoardModel': 'Set the device model on this category before uploading production firmware.',
  'pages.productCategory.firmware.defaultExplain': 'If no row is marked default, GenerateLicense picks the latest version by semver; you can set any version as default. The first upload becomes default automatically.',
  'pages.productCategory.firmware.addTitle': 'Add firmware',
  'pages.productCategory.firmware.displayName': 'Firmware name',
  'pages.productCategory.firmware.nameRequired': 'Enter a firmware name',
  'pages.productCategory.firmware.namePh': 'e.g. Release 2025Q1',
  'pages.productCategory.firmware.version': 'Version',
  'pages.productCategory.firmware.versionRequired': 'Enter version x.y.z.w',
  'pages.productCategory.firmware.versionFormat': 'Version must be x.y.z.w',
  'pages.productCategory.firmware.file': 'Firmware file',
  'pages.productCategory.firmware.selectBin': 'Choose .bin (filename does not need to match the version field)',
  'pages.productCategory.firmware.upload': 'Upload',
  'pages.productCategory.firmware.listTitle': 'Firmware list',
  'pages.productCategory.firmware.colName': 'Name',
  'pages.productCategory.firmware.colUploadedAt': 'Uploaded at',
  'pages.productCategory.firmware.colVersion': 'Version',
  'pages.productCategory.firmware.colBoard': 'Board type',
  'pages.productCategory.firmware.colDefault': 'Default download',
  'pages.productCategory.firmware.defaultTag': 'Default',
  'pages.productCategory.firmware.setDefault': 'Set as default',
  'pages.productCategory.firmware.loadFailed': 'Failed to load',
  'pages.productCategory.firmware.needFile': 'Please select a .bin file',
  'pages.productCategory.firmware.filenameHint': 'Upload filename may differ from the version; the server stores the file as {version}.bin from the form',
  'pages.productCategory.firmware.uploadOk': 'Uploaded',
  'pages.productCategory.firmware.uploadFailed': 'Upload failed',
  'pages.productCategory.firmware.defaultOk': 'Default version updated',
  'pages.productCategory.firmware.defaultFailed': 'Failed to set default',
  'pages.productCategory.column.tenantCode': 'Partner tenant',
  'pages.productCategory.column.tenantCodeTip': 'Leave empty for platform-wide categories; partner accounts get supplier_code set by the server on create',
  'pages.productCategory.column.imageUrl': 'Category image',
  'pages.productCategory.column.animationVideoUrl': 'Animation video',
  'pages.productCategory.column.wakeWord': 'Wake word',
  'pages.productCategory.column.wakeWordPlaceholder': 'Separate multiple wake words with commas, default: 你好小智,Jarvis',
  'pages.productCategory.upload.imageHint': 'PNG only, max 1MB, uploaded to OSS',
  'pages.productCategory.upload.videoHint': 'MP4 only, max 10MB, uploaded to OSS',
  'pages.productCategory.confirm.Delete': 'Are you sure you want to delete this product category?',
  'pages.productCategory.deleteSuccess': 'Deletion successful',
  'pages.productCategory.deleteFailed': 'Deletion failed',
  'pages.productCategory.createSuccess': 'Saved successfully',
  'pages.productCategory.createFailed': 'Save failed',
  'pages.tenantProductFirmware.emptyHint': 'No product categories yet. Create a product category under "Enterprise Management → Product Categories" first, then come back here to upload firmware for it.',
};
